import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles<ITheme>((theme) => ({
  drawerHeader: {
    height: 68,
    position: 'fixed',
    width: 657,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      borderTopLeftRadius: 0,
    },
    borderBottom: `1px solid ${colors.lightGray}`,
    backgroundColor: colors.white,
    borderTopLeftRadius: 16,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
  },
  closeBtnWrapper: {
    position: 'absolute',
    right: 6,
    fontSize: 16,
    color: colors.darkestBlue,
  },
  backBtnWrapper: {
    position: 'absolute',
    left: 6,
    fontSize: 16,
    color: colors.darkestBlue,
  },
  icon: {
    marginRight: 8,
  },
  content: {
    paddingTop: 68,
    [theme.breakpoints.down('xs')]: {
      minHeight: '100vh',
    },
  },
  drawerFooter: {
    width: 657,
    height: 68,
    bottom: 0,
    position: 'fixed',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      borderRadius: 0,
    },
    borderTop: `1px solid ${colors.lightGray}`,
    backgroundColor: colors.white,
    zIndex: 1000,
    display: 'inline-grid',
    alignItems: 'center',
    borderBottomLeftRadius: 16,
  },
  footerButton: {
    width: 'fit-content',
    height: 42,
    fontSize: 14,
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  ctaWrapper: {
    textAlign: 'right',
    margin: '0 40px',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  secondaryCta: {
    fontSize: 16,
    fontWeight: 700,
    color: colors.darkestBlue,
    lineHeight: '21px',
    cursor: 'pointer',
  },
}));
